import React, { useState } from "react";
import "./Otp.css";
import { allowedOtpKeys } from "./../../../utils/allowedOtpKeys";
import { isNewUI } from "../../../utils/handleProgress";
import { useEffect } from "react";

const Otp = (props) => {
  const {
    wrongOtpErr,
    removeWrongOtpClass,
    inputFunction,
    autofilledOtpFunction,
  } = props;
  const [otpArray, setOtpArray] = useState([]);

  useEffect(() => {
    if (isNewUI()) {
      webOtpHandler();
    }
  }, []);

  useEffect(() => {
    inputFunction();
  }, [otpArray]);

  const setOtpText = (value) => {
    const otp = value?.toString()?.split("");
    fillOtp(otp);
  };

  const onPasteHandler = (e) => {
    setOtpText(e.clipboardData.getData("Text"));
  };
  const webOtpHandler = () => {
    if ("OTPCredential" in global?.window) {
      const signal = new global.window.AbortController();

      global.window.navigator.credentials
        .get({
          abort: signal,
          otp: { transport: ["sms"] },
        })
        .then((otpValue) => {
          const otp = otpValue?.code?.toString()?.split("");

          fillOtp(otp);

          setTimeout(() => {
            signal.abort();
          }, 1000);
        })
        .catch((err) => {
          signal.abort();
        });
    } else {
    }
  };

  const fillOtp = (otp) => {
    setOtpArray(otp);
  };

  const inputValueChanged = (e, index) => {
    const value = e.target.value;

    if (value.length === 6) {
      setOtpText(value);
    } else {
      let array = [...otpArray];

      if (value.length > 1) {
        let arr = value.split("");
        if (index < 5) {
          array[index] = arr[0];
          array[index + 1] = arr[1];
        } else {
          array[index] = arr[0];
        }
      } else {
        array[index] = e.target.value;
      }

      setOtpArray(array);

      if (value) {
        const input = document.getElementById(
          `OTPinput_${index < 5 ? index + 1 : index}`
        );
        input.focus();
      } else {
        const input = document.getElementById(
          `OTPinput_${index > 0 ? index - 1 : index}`
        );

        input.focus();
      }
    }
  };

  const handleKeyDown = (event, index) => {
    autofilledOtpFunction("N");
    if (event.key === "Backspace" && !otpArray[index]) {
      const input = document.getElementById(
        `OTPinput_${index > 0 ? index - 1 : index}`
      );

      input.focus();
    }
  };

  return (
    <>
      <input
        type="text"
        inputMode="numeric"
        autoFocus={true}
        id={`OTPinput_0`}
        disabled={props.submitting}
        className={`${wrongOtpErr ? "input_otp red_brdr_otp" : "input_otp"}`}
        value={otpArray.length ? otpArray[0] : ""}
        onPaste={onPasteHandler}
        autocomplete="one-time-code"
        onChange={(e) => inputValueChanged(e, 0)}
        onKeyUp={(e) => handleKeyDown(e, 0)}
      />
      <input
        type="text"
        inputMode="numeric"
        id={`OTPinput_1`}
        disabled={props.submitting}
        className={`${wrongOtpErr ? "input_otp red_brdr_otp" : "input_otp"}`}
        value={otpArray.length ? otpArray[1] : ""}
        onPaste={onPasteHandler}
        autocomplete="one-time-code"
        onChange={(e) => inputValueChanged(e, 1)}
        onKeyUp={(e) => handleKeyDown(e, 1)}
      />
      <input
        type="text"
        inputMode="numeric"
        id={`OTPinput_2`}
        disabled={props.submitting}
        className={`${wrongOtpErr ? "input_otp red_brdr_otp" : "input_otp"}`}
        value={otpArray.length ? otpArray[2] : ""}
        onPaste={onPasteHandler}
        autocomplete="one-time-code"
        onChange={(e) => inputValueChanged(e, 2)}
        onKeyUp={(e) => handleKeyDown(e, 2)}
      />
      <input
        type="text"
        inputMode="numeric"
        id={`OTPinput_3`}
        disabled={props.submitting}
        className={`${wrongOtpErr ? "input_otp red_brdr_otp" : "input_otp"}`}
        value={otpArray.length ? otpArray[3] : ""}
        onPaste={onPasteHandler}
        autocomplete="one-time-code"
        onChange={(e) => inputValueChanged(e, 3)}
        onKeyUp={(e) => handleKeyDown(e, 3)}
      />
      <input
        type="text"
        inputMode="numeric"
        id={`OTPinput_4`}
        disabled={props.submitting}
        className={`${wrongOtpErr ? "input_otp red_brdr_otp" : "input_otp"}`}
        value={otpArray.length ? otpArray[4] : ""}
        onPaste={onPasteHandler}
        autocomplete="one-time-code"
        onChange={(e) => inputValueChanged(e, 4)}
        onKeyUp={(e) => handleKeyDown(e, 4)}
      />
      <input
        type="text"
        inputMode="numeric"
        id={`OTPinput_5`}
        disabled={props.submitting}
        className={`${wrongOtpErr ? "input_otp red_brdr_otp" : "input_otp"}`}
        value={otpArray.length ? otpArray[5] : ""}
        onPaste={onPasteHandler}
        autocomplete="one-time-code"
        onChange={(e) => inputValueChanged(e, 5)}
        onKeyUp={(e) => handleKeyDown(e, 5)}
      />
    </>
  );
};

export default Otp;
